import { render, staticRenderFns } from "./SexCell.vue?vue&type=template&id=6f8c8914&scoped=true&"
import script from "./SexCell.vue?vue&type=script&lang=babel&"
export * from "./SexCell.vue?vue&type=script&lang=babel&"
import style0 from "./SexCell.vue?vue&type=style&index=0&id=6f8c8914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8c8914",
  null
  
)

export default component.exports